<template>
	<ProfileSelectionMenu
		contextMode
		:profileId="workflowVersion.app_credentials_configuration.credentials"
		:serviceId="serviceId"
		:serviceVersionId="serviceVersionId"
		:disableRealProfiles="disableRealProfiles"
		:showLoadingStatus="false"
		:configurationId="configurationId"
		:credentialsType="workflowVersion.app_credentials_configuration.credentials_type"
		:sourceFieldUUID="workflowVersion.app_credentials_configuration.source_field_uuid"
		:secondaryTitle="secondaryTitle"
		:hasEditPermissions="hasEditPermissions"
	/>
</template>

<script>
import { getService } from '@/store/modules/apps/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AppService from '@/utils/AppService';
import ProfileSelectionMenu from '../IntegrationEditor/ProfileSelection/ProfileSelectionMenu.vue';
import { canEditWorkflow } from '@/store/modules/workflows/getters';
export default {
	name: 'FormItemCredentialsSelector',
	props: {
		workflowVersion: { type: Object },
		serviceId: { type: Number },
		serviceVersionId: { type: String },
		disableRealProfiles: { type: Boolean },
		configurationId: { type: Number },
		effectedNode: { type: Object },
	},
	components: { ProfileSelectionMenu },
	computed: {
		...mapGettersShorthand({ getService, canEditWorkflow }),
		service() {
			return this.getService(this.serviceId);
		},
		hasEditPermissions() {
			return this.canEditWorkflow(this.workflowVersion.original);
		},
		secondaryTitle() {
			let title = '';
			if (AppService.doesAppSupportAccountWorkspaces(this.service)) {
				title += 'Also affects which account this add-on is displayed on. ';
			}
			if (this.effectedNode) {
				title += `Also used to get contextual data in step \`${this.effectedNode.node_title}\``;
			}
			return title.trim(); // remove backspaces
		},
	},
};
</script>
<style lang="scss" scoped></style>
